import { render } from "./universityDetail.vue?vue&type=template&id=ac06e954&scoped=true"
import script from "./universityDetail.vue?vue&type=script&lang=js"
export * from "./universityDetail.vue?vue&type=script&lang=js"

import "./universityDetail.vue?vue&type=style&index=0&id=ac06e954&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac06e954"]])

export default __exports__